<template>
<div class="chapter">
<div class="inner_page">
<p class="C829"><strong><span id="page_ix">Tables </span>and Figures </strong></p>
<p class="P34">TABLES </p>
<table class="ill1">
<tbody><tr>
<td valign="top"><p class="C972"><a href="#/html/10_CHAPTER#id_107">Table 1</a></p></td>
<td valign="top"><p class="C972"><a href="#/html/10_CHAPTER#id_107">Growth of African American population in Oakwood </a></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><a href="#/html/10_CHAPTER#id_119">Table 2</a></p></td>
<td valign="top"><p class="C972"><a href="#/html/10_CHAPTER#id_119">Growth of Latino population in Venice and Oakwood </a></p></td>
</tr>
</tbody></table>
<p class="P36">FIGURES (MAPS AND PHOTOGRAPHS) </p>
<table class="ill">
<tbody><tr>
<td valign="top"><p class="P335"><a href="#/html/09_Introduc#id_8">Figure 1</a></p></td>
<td valign="top"><p class="P335"><a href="#/html/09_Introduc#id_8">Map of Venice tour </a></p></td>
</tr>
<tr>
<td valign="top"><p class="P335"><a href="#/html/10_CHAPTER#id_75">Figure 2</a></p></td>
<td valign="top"><p class="P335"><a href="#/html/10_CHAPTER#id_75">Oil derricks on the beach </a></p></td>
</tr>
<tr>
<td valign="top"><p class="C972-1"><span href="#/html/11_CHAPTER#id_170" title="Link target outside of Sample">Figure 3</span></p></td>
<td valign="top"><p class="C972-1"><span href="#/html/11_CHAPTER#id_170" title="Link target outside of Sample">Map of the distribution of housing projects in Oakwood </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972-1"><span href="#/html/11_CHAPTER#id_178" title="Link target outside of Sample">Figure 4</span></p></td>
<td valign="top"><p class="C972-1"><span href="#/html/11_CHAPTER#id_178" title="Link target outside of Sample">Oakwood Recreation Center with Shoreline Crip tag </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/11_CHAPTER#id_187" title="Link target outside of Sample">Figure 5</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/11_CHAPTER#id_187" title="Link target outside of Sample">Oakwood alleyway </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972-1"><span href="#/html/11_CHAPTER#id_196" title="Link target outside of Sample">Figure 6</span></p></td>
<td valign="top"><p class="C972-1"><span href="#/html/11_CHAPTER#id_196" title="Link target outside of Sample">Map of Latino residents’ church and park routes </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/11_CHAPTER#id_223" title="Link target outside of Sample">Figure 7</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/11_CHAPTER#id_223" title="Link target outside of Sample">Fence surrounding a house </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_253" title="Link target outside of Sample">Figure 8</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_253" title="Link target outside of Sample">Gates in front of boardwalk businesses </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_269" title="Link target outside of Sample">Figure 9</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_269" title="Link target outside of Sample">Sponto Gallery </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_271" title="Link target outside of Sample">Figure 10</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_271" title="Link target outside of Sample">RVs near Rose Avenue </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_277" title="Link target outside of Sample">Figure 11</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/12_CHAPTER#id_277" title="Link target outside of Sample">Homeless encampment </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/13_CHAPTER#id_285" title="Link target outside of Sample">Figure 12</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/13_CHAPTER#id_285" title="Link target outside of Sample">Canal sidewalks prior to redevelopment </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/13_CHAPTER#id_310" title="Link target outside of Sample">Figure 13</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/13_CHAPTER#id_310" title="Link target outside of Sample">Canal cleanup campaign on empty lot </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/13_CHAPTER#id_346" title="Link target outside of Sample">Figure 14</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/13_CHAPTER#id_346" title="Link target outside of Sample">Scenic Venice Canals </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/14_CHAPTER#id_363" title="Link target outside of Sample">Figure 15</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/14_CHAPTER#id_363" title="Link target outside of Sample">Venice Boardwalk scene </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/14_CHAPTER#id_370" title="Link target outside of Sample">Figure 16</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/14_CHAPTER#id_370" title="Link target outside of Sample">Venice Beach carnival performer </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/14_CHAPTER#id_409" title="Link target outside of Sample">Figure 17</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/14_CHAPTER#id_409" title="Link target outside of Sample">Homeless performer </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_425" title="Link target outside of Sample">Figure 18</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_425" title="Link target outside of Sample">Abandoned storefront </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_444" title="Link target outside of Sample">Figure 19</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_444" title="Link target outside of Sample">Thrift shop </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_446" title="Link target outside of Sample">Figure 20</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_446" title="Link target outside of Sample">High-end shop mimicking thrift presentation </span></p></td>
</tr>
<tr>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_454" title="Link target outside of Sample">Figure 21</span></p></td>
<td valign="top"><p class="C972"><span href="#/html/15_CHAPTER#id_454" title="Link target outside of Sample">New artist lofts </span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_List_of.vue?96769e18